import script from "./SubscribersList.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribersList.vue?vue&type=script&setup=true&lang=js"

import "./SubscribersList.vue?vue&type=style&index=0&id=b65d29ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b65d29ce"]])

export default __exports__